import React, { useEffect, useState, useContext, useRef } from "react";
import "./consultation.css";
import AOS from "aos";
import { toast } from "react-toastify";
import { SwiperSlide } from "swiper/react";
import { getMoshaverehPackages } from "../../axios";
import BlogNews from "../../components/common/BlogNews";
import { useAppSelector } from "./../../store/configureStore";
import { CartContext } from "../../components/shared/context/cart-context";
import SliderPagination from "../../components/common/SliderPagination";

import logo from "../../assets/img/consultation/transparent-logoBanner.png";
import readingBox1 from "../../assets/img/consultation/reading-box3.JPG";
import readingBox2 from "../../assets/img/consultation/reading-box2.JPG";
import whyUsLogo from "../../assets/img/consultation/new-logo.png";
import doctorImg from "../../assets/img/consultation/213.png";
import questionImg from "../../assets/img/consultation/questionImg.png";
import inActiveIcon from "../../assets/img/consultation/delete_14025328.png";
import activeIcon from "../../assets/img/consultation/circle_14025310.png";
import avDoctor from "../../assets/img/consultation/1.png";
import avatar1 from "../../assets/img/consultation/2.JPG";
import avatar2 from "../../assets/img/consultation/3.jpg";
import avatar3 from "../../assets/img/consultation/4.jpg";
import avatar4 from "../../assets/img/consultation/5.jpg";
import avatar5 from "../../assets/img/consultation/6.jpg";
import avatar6 from "../../assets/img/consultation/7.jpg";
import avatar7 from "../../assets/img/consultation/8.jpg";
import avatar8 from "../../assets/img/consultation/9.jpg";
import avatar9 from "../../assets/img/consultation/10.jpg";
import avatar10 from "../../assets/img/consultation/11.JPG";
import avatar11 from "../../assets/img/consultation/12.jpg";
import manAvatar from "../../assets/img/consultation/man-user.png";
import womanAvatar from "../../assets/img/consultation/woman-user.png";
import { separate } from "../../tools/helper";
import scrollToTop from "../../components/ScrollTop";

const Consultation = () => {
  const [activeId, setActiveId] = useState(1);
  const { user } = useAppSelector((state) => state.account);
  const [cartItems, setCartItems] = useContext(CartContext);
  const firstPlan = useRef(null);
  const secondPlan = useRef(null);
  const thirdPlan = useRef(null);
  const searchParams = new URLSearchParams(location.search);

  const [moshaverehPackages, setMoshaverehPackages] = useState([
    {
      title: "پکیج اقتصادی",
      activeDetails: [
        "تحت نظارت مداوم یک رتبه برتر با شرایط نزدیک به شما ",
        "تعیین منابع مناسب طبق شرایط داوطلب ",
        "تعیین ساعت مطالعه با توجه به شرایط و هدف ",
        "تعیین تعداد دور مطالعه با توجه به شرایط و هدف ",
        "تشکیل گروه تلگرامی اختصاصی هر داوطلب ",
        "جلسات تلفنی هر 2هفته یکبار با مشاور اختصاصی ",
        "تعیین بودجه بندی ماهانه و هر 2 هفته یکبار ",
        "عضویت در کانال VIP آتروپین ",
        "پشتیبانی و پیگیری از طریق گروه تلگرامی ",
      ],
      inactiveDetails: [
        "باکس مطالعاتی با جزئیات کامل ",
        "جلسات ماهانه با دکتر نایب زاده یا مشاورین ارشد گروه ",
      ],
    },
    {
      title: "پکیج کامل",
      activeDetails: [
        "تحت نظارت مداوم یک رتبه برتر با شرایط نزدیک به شما ",
        "تعیین منابع مناسب طبق شرایط داوطلب ",
        "تعیین ساعت مطالعه با توجه به شرایط و هدف ",
        "تعیین تعداد دور مطالعه با توجه به شرایط و هدف ",
        "تشکیل گروه تلگرامی اختصاصی هر داوطلب ",
        "جلسات تلفنی هر 2هفته یکبار با مشاور اختصاصی ",
        "تعیین بودجه بندی ماهانه و هر 2 هفته یکبار ",
        "عضویت در کانال VIP آتروپین ",
        "پشتیبانی و پیگیری مداوم از طریق گروه تلگرامی ",
        "باکس مطالعاتی با جزئیات کامل ",
      ],
      inactiveDetails: ["جلسات ماهانه با دکتر نایب زاده یا مشاورین ارشد گروه "],
    },
    {
      title: "پکیج VIP",
      activeDetails: [
        "تحت نظارت مداوم یک رتبه برتر با شرایط نزدیک به شما ",
        "تعیین منابع مناسب طبق شرایط داوطلب ",
        "تعیین ساعت مطالعه با توجه به شرایط و هدف ",
        "تعیین تعداد دور مطالعه با توجه به شرایط و هدف ",
        "تشکیل گروه تلگرامی اختصاصی هر داوطلب ",
        "جلسات تلفنی هر 2هفته یکبار با مشاور اختصاصی ",
        "تعیین بودجه بندی ماهانه و هر 2 هفته یکبار ",
        "عضویت در کانال VIP آتروپین ",
        "پشتیبانی و پیگیری مداوم از طریق گروه تلگرامی ",
        "باکس مطالعاتی با جزئیات کامل ",
        "جلسات ماهانه با دکتر نایب زاده یا مشاورین ارشد گروه ",
      ],
      inactiveDetails: [],
    },
  ]);

  const testimonialData = [
    {
      id: 1,
      content:
        "بدون اغراق بهترین و حرفای ترین تیم هستید شما. شما رو به دوستام هم معرفی کردم. از دکتر نایب زاده هم مچکرم واسه این تیم خفن",
      name: "پردیس",
      role: "داوطلب دستیاری",
      imgUrl: womanAvatar,
    },
    {
      id: 2,
      content:
        "سلام سپاسگزارم از تیم آتروپین. بهترین گروه مشاوره هستید قطعا. من از روزی صفر ساعت مطالعه رسیدم به روزی 10 ساعت! واقعا خوشحالم با شما آشنا شدم.",
      name: "امیر",
      role: "داوطلب پرهانترنی",
      imgUrl: manAvatar,
    },
    {
      id: 3,
      content:
        "این یک ماه با پیگیری های دکتر منتظمی جوری شده بود که اصلا نمیشد درس نخونم! برنامه هایی که میدادن و راهنمایی هایی که داشتن باعث شد انگیزه بگیرم و هر روز تلاشم رو بیشتر کنم.",
      name: "غزل",
      role: "استاجر پزشکی",
      imgUrl: womanAvatar,
    },
    {
      id: 4,
      content:
        "من قبل از آشنایی با شما با دوتا گروه مشاوره دیگه پیش رفتم که به هیچکدوم از حرفایی که میزدن عمل نمی کردن. حتی می گفتن برنامه میدیم ولی دریغ از یه برنامه! شما حتی از چیزی که میگفتید هم بهتر بودید تا اینجا. خیلی ممنونم ازتون.",
      name: "پیمان",
      role: "داوطلب دستیاری",
      imgUrl: manAvatar,
    },
  ];

  const teamData = [
    {
      id: 1,
      name: "دکتر امیرحسین نایب زاده",
      role: "مشاور ارشد گروه آتروپین",
      imageUrl: avDoctor,
      detail: [
        "ارولوژیست . فلوشیپ پیوند کلیه",
        "هیئت علمی دانشگاه شهید بهشتی",
        "موسس و مدیر مجموعه آتروپین",
      ],
    },
    {
      id: 2,
      name: "دکتر امین ناصح",
      role: "مشاور ارشد گروه آتروپین",
      imageUrl: avatar1,
      detail: ["رتبه 6 دستیاری 50", "رزیدنت پوست دانشگاه تهران"],
    },
    {
      id: 3,
      name: "دکتر هومن شیرزادی",
      role: "مشاور برتر گروه آتروپین",
      imageUrl: avatar2,
      detail: ["رتبه 9 دستیاری 51"],
    },
    {
      id: 4,
      name: "دکتر مریم جهانبخش ",
      role: "مشاور برتر گروه آتروپین",
      imageUrl: avatar3,
      detail: ["رتبه 29 دستیاری 51"],
    },
    {
      id: 5,
      name: "دکتر امیر کشاورز",
      role: "مشاور برتر گروه آتروپین",
      imageUrl: avatar4,
      detail: ["رتبه 48 دستیاری 51 و رتبه پره انترنی"],
    },
    {
      id: 6,
      name: "دکتر ثنا جفائی ",
      role: "مشاور برتر گروه آتروپین",
      imageUrl: avatar5,
      detail: ["رتبه 48 دستیاری 51"],
    },
    {
      id: 7,
      name: "دکتر امین امینی ",
      role: "مشاور برتر گروه آتروپین",
      imageUrl: avatar6,
      detail: ["رتبه 66 دستیاری 51"],
    },
    {
      id: 8,
      name: "دکتر محمد نعمتی ",
      role: "مشاور برتر گروه آتروپین",
      imageUrl: avatar7,
      detail: ["رتبه 67 دستیاری 50 و رتبه پره انترنی", "رزیدنت چشم تبریز"],
    },
    {
      id: 9,
      name: "دکتر محمد منتظمی ",
      role: "مشاور برتر گروه آتروپین",
      imageUrl: avatar8,
      detail: ["رتبه 71 دستیاری 50", "رزیدنت قلب مشهد"],
    },
    {
      id: 10,
      name: "دکتر امیر سعیدی",
      role: "مشاور برتر گروه آتروپین",
      imageUrl: avatar9,
      detail: ["رتبه 80 دستیاری 50", "رزیدنت رادیولوژی تبریز"],
    },
    {
      id: 11,
      name: "دکتر رضا درستی ",
      role: "مشاور برتر گروه آتروپین",
      imageUrl: avatar10,
      detail: ["رتبه 114 دستیاری 50"],
    },
    {
      id: 12,
      name: "دکتر فائزه جعفری",
      role: "مشاور برتر گروه آتروپین",
      imageUrl: avatar11,
      detail: ["رتبه 130 دستیاری 50", "رزیدنت پوست مشهد"],
    },
  ];

  const faqData = [
    {
      id: 1,
      question: "لورم ایپسوم",
      answer:
        "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر...",
    },
    {
      id: 2,
      question: "لورم ایپسوم متن ساختگی",
      answer:
        "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر...",
    },
    {
      id: 3,
      question: "لورم ایپسوم متن ساختگی با تولید",
      answer:
        "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر...",
    },
  ];

  //handle soalatmotadavel clicking
  const handleAccordionClick = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  //finding if the current package is already in basket
  const existsInBasket = (array, id) => {
    return array.some((item) => item.id === id);
  };

  const handleAddToBasket = (e, value) => {
    e.preventDefault();
    if (user) {
      let basket = [...cartItems];

      const existItemInBasket = existsInBasket(cartItems, value.id);

      if (existItemInBasket == false) {
        try {
          basket.push(value);
          setCartItems(basket);
          toast.success("به سبد خرید اضافه شد");
        } catch (error) {
          console.log(error.message);
        }
      } else {
        toast.error(
          "کاربر گرامی محصول مورد نظر را قبلا به سبد خرید اضافه کرده اید"
        );
      }
    } else {
      toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
    }
  };

  const searchQuery = new URLSearchParams(location.search);
  const packageId = searchQuery.get("scrollPackages");

  useEffect(() => {
    if (packageId) {
      if (packageId == "73") {
        firstPlan?.current.scrollIntoView();
      } else if (packageId == "75") {
        secondPlan?.current.scrollIntoView();
      } else if (packageId == "76") {
        thirdPlan?.current.scrollIntoView();
      } else {
        scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }
  }, [packageId]); // Runs when packageId changes

  //getting moshavere 3 plan packages
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getMoshaverehPackages();

        if (data) {
          // Slice the first 3 items
          const slicedApiData = data.slice(0, 3);

          const updatedPackages = moshaverehPackages.map((pkg, index) => {
            // Check if there's a corresponding price from the API at the same index
            if (data[index]) {
              return {
                ...slicedApiData[index],
                title: pkg.title,
                ...pkg,
              };
            }
            return pkg;
          });

          setMoshaverehPackages(updatedPackages);
        }
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);

  return (
    <div className="consultation-container">
      {/* FIRST SECTION */}
      <section id="slide" class="hero-section">
        <div class="content-bottom">
          <div class="container">
            <div class="row px-0  px-xl-5 align-items-center">
              <div
                class="col-md-6 d-flex flex-column gap-3"
                data-aos="fade-left"
              >
                <p class="mb-0">لحظه لحظه این مسیر کنارتان هستیم</p>
                <h2>تا موفقیت</h2>
                <p>
                  گروه مشاوره آتروپین با مدیریت دکتر امیرحسین نایب زاده و در
                  کنار رتبه برترهای آزمونهای دستیاری و پره انترنی سالهای اخیر،
                  به گونه ای متفاوت در این مسیر شما را همراهی میکند
                </p>
                <a href="#doctor_img" class="readMore-btn">
                  <span>بیشتر بخوانید</span>
                </a>
              </div>
              <div class="col-md-6" data-aos="fade-right" data-aos-delay="200">
                <img src={logo} class="leftBanner d-block mx-auto" alt="logo" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="consultation-aparat-videos h-100">
        <div className="d-flex">
          <div class="h_iframe-aparat_embed_frame iframe-container">
            <span style={{display: "block",paddingTop: "57%"}}></span>
            <iframe
              src="https://www.aparat.com/video/video/embed/videohash/gmbuh4r/vt/frame"
              allowFullScreen="true"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
            ></iframe>
          </div>
          <div class="h_iframe-aparat_embed_frame iframe-container">
            <span style={{display: "block",paddingTop: "57%"}}></span>
            <iframe
              src="https://www.aparat.com/video/video/embed/videohash/xrareue/vt/frame"
              allowFullScreen="true"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
            ></iframe>
          </div>
        </div>
      </section>

      <div className="w-100 d-flex align-items-center justify-content-center pt-5">
        <h2 className="fw-bold">بهترین موسسه برای آزمون دستیاری</h2>
      </div>

      {/* BOXES SECTION */}
      <section id="boxes" class="boxes">
        <div class="container-fluid px-0 px-xl-5">
          <div class="row px-0 px-xl-5 py-5">
            <div class="col-md-4 col-12">
              <div class="box" data-aos="fade-up" data-aos-delay="200">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
                  </svg>
                </div>
                <h4>جلسات منظم</h4>
                <p>
                  هر داوطلب به صورت منظم هر 2 هفته یکبار با مشاور خود جلسه تلفنی
                  خواهد داشت که ماحصل آن برنامه دو هفته پیش روی اوست.
                </p>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <div class="box" data-aos="fade-up">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128s-128-57.3-128-128V102.9L48 93.3v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z" />
                  </svg>
                </div>
                <h4>مشاوره فردی</h4>
                <p>
                  مشاور اختصاصی شما، تایم مطالعه روزانه و حتی منابع مطالعاتی هر
                  فرد بر اساس شرایط اختصاصی وی تنظیم خواهد شد و برنامه پیش فرضی
                  برای تمامی داوطلبین وجود ندارد.
                </p>
              </div>
            </div>

            <div class="col-md-4 col-12">
              <div class="box" data-aos="fade-up" data-aos-delay="400">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V400.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24H240c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z" />
                  </svg>
                </div>
                <h4>پشتیبانی مداوم </h4>
                <p>
                  در فواصل بین جلسات، از طریق گروه تلگرامی شامل داوطلب، مشاور و
                  دکترنایب زاده پیگیری منظم خواهید داشت و به تمامی سوالاتتان در
                  فواصل بین جلسات نیز پاسخ داده خواهد شد.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHY US SECTION */}
      <section id="about" class="why-us">
        <div className="bg-overLay"></div>
        <div class="container">
          <div class="row align-items-center">
            <div class="col-12 col-lg-6  text-center pb-5" data-aos="fade-left">
              <img src={whyUsLogo} alt="" />
            </div>
            <div
              class="col-12 col-lg-6 d-flex flex-column gap-4"
              data-aos="fade-zoom-in"
              data-aos-delay="200"
            >
              <h3>پیمودن این مسیر همراهی حرفه ای می طلبد</h3>
              <p className="mb-3">
                هر دانشجوی پزشکی در مقاطع مختلف تحصیل خود با سوالات متعددی روبرو
                خواهد شد، از انتخاب منابع تا نحوه برخورد با حجم بالای مطالب،
                شیوه جمع بندی و از همه مهمتر آماده شدن برای آزمونهای مهم پیش روی
                خود.
              </p>
              <p className="mb-3">
                گروه مشاوره آتروپین در زمینه های زیر در کنارتان خواهد بود
              </p>
              <div class="row">
                <div
                  class="col-lg-12 col-md-12 col-sm-12 col-12 px-4 mb-4"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                >
                  <div class="why-us-icon">
                    <span class="lnr lnr-rocket"></span>
                    <li>مشاوره تحصیلی مقاطع فیزیوپات تا اینترنی</li>
                  </div>
                </div>
                <div
                  class="col-lg-6 col-md-6 col-sm-6 col-12 px-4"
                  data-aos="zoom-in"
                  data-aos-delay="600"
                >
                  <div class="why-us-icon">
                    <span class="lnr lnr-rocket"></span>
                    <li>مشاوره آزمون پره انترنی</li>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-6 col-md-6 col-sm-6 col-12 px-4 mb-4"
                  data-aos="zoom-in"
                  data-aos-delay="800"
                >
                  <div class="why-us-icon">
                    <span class="lnr lnr-rocket"></span>
                    <li>مشاوره آزمون دستیاری</li>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MAIN FEATURES SECTION */}
      <section id="main_features" class="main-features">
        <div class="container d-flex flex-column gap-4">
          <div class="row">
            <div
              class="text-center col-12 section-title"
              data-aos="fade-zoom-in"
            >
              <h3 className="main-title">
                <span>چرا همراهی ما</span>بهترین انتخاب <span>برای شماست؟</span>
              </h3>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-lg-3 text-lg-right left-side">
              <div
                class="one-feature one"
                data-aos="fade-left"
                data-aos-delay="1000"
              >
                <h5>
                  مدیریت برجسته{" "}
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z" />
                  </svg>
                </h5>
                <span class="lnr lnr-rocket"></span>
                <p>
                  حضور دکترنایب زاده در تمامی گروههای تلگرامی داوطلبین و نظارت
                  بر سیر پشتیبانی مشاور و روند پیشرفت داوطلب
                </p>
              </div>
              <div
                class="one-feature"
                data-aos="fade-left"
                data-aos-delay="1400"
              >
                <h5>
                  مشاورین گروه{" "}
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                    <path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z" />
                  </svg>
                </h5>
                <span class="lnr lnr-cog"></span>
                <p>
                  تمامی مشاورین گروه آتروپین رتبه برترهای آزمون پره انترنی و یا
                  رتبه زیر 100 آزمون دستیاری میباشند
                </p>
              </div>
              <div
                class="one-feature"
                data-aos="fade-left"
                data-aos-delay="1800"
              >
                <h5>
                  برنامه ریزی اختصاصی{" "}
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
                  </svg>
                </h5>
                <span class="lnr lnr-cloud"></span>
                <p>
                  در گروه آتروپین برنامه از قبل تعیین شده ای وجود ندارد و تمامی
                  مراحل مشاوره داوطلب از انتخاب مشاور تا انتخاب منابع و ... بر
                  اساس شرایط فردی او صورت میگیرد{" "}
                </p>
              </div>
            </div>
            <div class="col-lg-6 text-center">
              <div class="features-circle">
                <div
                  id="doctor_img"
                  className="circleImg-container"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <img
                    data-aos="fade-up"
                    data-aos-delay="400"
                    src={doctorImg}
                    class="doctor-img"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-3 right-side">
              <div
                class="one-feature"
                data-aos="fade-right"
                data-aos-delay="1000"
              >
                <h5>
                  جلسات منظم{" "}
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
                  </svg>
                </h5>
                <span class="lnr lnr-construction"></span>
                <p>
                  هر داوطلب به صورت منظم هر 2 هفته یکبار با مشاور خود جلسه تلفنی
                  خواهد داشت که ماحصل آن برنامه دو هفته پیش روی اوست.{" "}
                </p>
              </div>
              <div
                class="one-feature"
                data-aos="fade-right"
                data-aos-delay="1400"
              >
                <h5>
                  پشتیبانی مداوم{" "}
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V400.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24H240c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z" />
                  </svg>
                </h5>
                <span class="lnr lnr-gift"></span>
                <p>
                  در فواصل بین جلسات، از طریق گروه تلگرامی شامل داوطلب، مشاور و
                  دکترنایب زاده پیگیری منظم خواهید داشت و به تمامی سوالاتتان در
                  فواصل بین جلسات نیز پاسخ داده خواهد شد.
                </p>
              </div>
              <div
                class="one-feature"
                data-aos="fade-right"
                data-aos-delay="1800"
              >
                <h5>
                  طرح های مختلف{" "}
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" />
                  </svg>
                </h5>
                <span class="lnr lnr-database"></span>
                <p>
                  برای ایجاد تنوع در سطح قیمت ها برای راحتی داوطلبین، پکیج های
                  مختلفی در نظر گرفته شده تا حق انتخاب را برای داوطلب ایجاد کند
                  که در ادامه به آن میپردازیم.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VIDEO SECTION */}
      {/* <section id="watch_video" class="watch-video">
        <div class="container-fluid">
          <div class="row  d-flex align-items-center justify-content-center">
            <div
              class="text-center col-12 section-title mb-5"
              data-aos="fade-zoom-in"
            >
              <h3 className="main-title">
                <span> صحبت های</span> مدیریت<span> مجموعه</span>
              </h3>
              <p className="text-belowTitle">
                در این ویدئو دکتر نایب زاده مشاور ارشد گروه به توضیحاتی پیرامون
                گروه مشاوره آتروپین و روند جلسات مشاوره پرداخته اند.
              </p>
            </div>
            <div class="col-10" data-aos="fade-up">
              <div class="video">
                <img src={doctorImg} class="img-fluid d-block mx-auto" alt="" />
                <a href="#"></a>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* SOKHAN MOSHTARIAN SECTION */}
      <section id="testimonial" class="clients-testimonial">
        <div class="container">
          <div class="row">
            <div
              class="text-center col-12 section-title"
              data-aos="fade-zoom-in"
            >
              <h3 className="main-title">
                داوطلبین<span> ما</span>
              </h3>
              <p className="text-belowTitle">
                نظرات داوطلبین گروه مشاوره آتروپین در مورد همراهی ما
              </p>
            </div>
            <div class="col-12">
              <div class="testimonial-slider" data-aos="fade-up">
                <SliderPagination
                  slidesPerGroup={1}
                  slidesToShow={1}
                  responsiveSettings={{
                    768: { slidesPerView: 2, slidesPerGroup: 2 },
                  }}
                >
                  {testimonialData.map((item) => (
                    <SwiperSlide key={item.id}>
                      <div class="item mb-5">
                        <div class="client-testimonial">
                          <p className="fs-6">{item.content}</p>
                        </div>
                        <div class="client-info d-flex align-items-center">
                          <figure>
                            <img src={item?.imgUrl} class="" alt="" />
                          </figure>
                          <div className="d-flex flex-column gap-2">
                            <h3>{item.name}</h3>
                            <h6>{item.role}</h6>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </SliderPagination>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* THREE PRICE PLANS SECTION */}

      <section id="prices" class="prices d-flex flex-column">
        <div class="container">
          <div class="row">
            <div
              class="text-center col-12 section-title"
              data-aos="fade-zoom-in"
            >
              <h3 className="main-title">
                <span> پکیج های مشاوره </span> آتروپین
              </h3>

              <p className="text-belowTitle">
                برای ایجاد تنوع در سطح قیمت ها برای راحتی داوطلبین، پکیج های
                مختلفی در نظر گرفته شده تا حق انتخاب را برای داوطلب ایجاد کند.
                در جداول زیر مشخصات هر پیکج را ملاحظه میکنید.
              </p>
            </div>
            {moshaverehPackages && (
              <>
                <div
                  className="col-lg-4 col-md-4 col-12"
                  ref={firstPlan} // Assign the ref
                  key={moshaverehPackages[0]}
                >
                  <div
                    className="price-table"
                    data-aos="fade-left"
                    data-aos-delay="400"
                  >
                    <div className="top background-fullwidth">
                      <h4>{moshaverehPackages[0].title}</h4>
                    </div>
                    <div className="bottom">
                      <ul className="mb-5">
                        {moshaverehPackages[0].activeDetails.map(
                          (detail, idx) => (
                            <li key={idx}>
                              {detail}
                              <span>
                                <img src={activeIcon} alt="" />
                              </span>
                            </li>
                          )
                        )}
                        {moshaverehPackages[0].inactiveDetails.length > 0 &&
                          moshaverehPackages[0].inactiveDetails.map(
                            (detail, idx) => (
                              <li key={idx}>
                                {detail}
                                <span>
                                  <img src={inActiveIcon} alt="" />
                                </span>
                              </li>
                            )
                          )}
                      </ul>
                      <div className="price-texts">
                        {moshaverehPackages[0].price !==
                          moshaverehPackages[0].priceTakhfif && (
                          <p className="text-danger text-decoration-line-through">
                            {separate(moshaverehPackages[0]?.price)} تومان
                          </p>
                        )}
                        <p className="main-price fs-5">
                          {separate(moshaverehPackages[0].priceTakhfif)} تومان
                        </p>
                      </div>
                      <div className="w-100 d-flex align-items-center justify-content-center">
                        {moshaverehPackages[1]?.inventory > 0 ? (
                          <button
                            onClick={(e) =>
                              handleAddToBasket(e, moshaverehPackages[0])
                            }
                            className="plan-btn fw-bold fs-6"
                          >
                            افزودن به سبد خرید
                          </button>
                        ) : (
                          <button
                            disabled
                            className="plan-btn disabled-btn fw-bold fs-6"
                          >
                            ظرفیت تکمیل
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* second */}
                <div
                  className="col-lg-4 col-md-4 col-12"
                  ref={secondPlan} // Assign the ref
                  key={moshaverehPackages[1]}
                >
                  <div
                    className="price-table"
                    data-aos="fade-left"
                    data-aos-delay="400"
                  >
                    <div className="top background-fullwidth">
                      <h4>{moshaverehPackages[1].title}</h4>
                    </div>
                    <div className="bottom">
                      <ul className="mb-5">
                        {moshaverehPackages[1].activeDetails.map(
                          (detail, idx) => (
                            <li key={idx}>
                              {detail}
                              <span>
                                <img src={activeIcon} alt="" />
                              </span>
                            </li>
                          )
                        )}
                        {moshaverehPackages[1].inactiveDetails.length > 0 &&
                          moshaverehPackages[1].inactiveDetails.map(
                            (detail, idx) => (
                              <li key={idx}>
                                {detail}
                                <span>
                                  <img src={inActiveIcon} alt="" />
                                </span>
                              </li>
                            )
                          )}
                      </ul>
                      <div className="price-texts">
                        {moshaverehPackages[1].price !==
                          moshaverehPackages[1].priceTakhfif && (
                          <p className="text-danger text-decoration-line-through">
                            {separate(moshaverehPackages[1].price)} تومان
                          </p>
                        )}
                        <p className="main-price fs-5">
                          {separate(moshaverehPackages[1].priceTakhfif)} تومان
                        </p>
                      </div>
                      <div className="w-100 d-flex align-items-center justify-content-center">
                        {moshaverehPackages[1]?.inventory > 0 ? (
                          <button
                            onClick={(e) =>
                              handleAddToBasket(e, moshaverehPackages[1])
                            }
                            className="plan-btn fw-bold fs-6"
                          >
                            افزودن به سبد خرید
                          </button>
                        ) : (
                          <button
                            disabled
                            className="plan-btn disabled-btn fw-bold fs-6"
                          >
                            ظرفیت تکمیل
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* third */}
                <div
                  className="col-lg-4 col-md-4 col-12"
                  ref={thirdPlan} // Assign the ref
                  key={moshaverehPackages[2]}
                >
                  <div
                    className="price-table"
                    data-aos="fade-left"
                    data-aos-delay="400"
                  >
                    <div className="top background-fullwidth">
                      <h4>{moshaverehPackages[2].title}</h4>
                    </div>
                    <div className="bottom">
                      <ul className="mb-5">
                        {moshaverehPackages[2].activeDetails.map(
                          (detail, idx) => (
                            <li key={idx}>
                              {detail}
                              <span>
                                <img src={activeIcon} alt="" />
                              </span>
                            </li>
                          )
                        )}
                        {moshaverehPackages[2].inactiveDetails.length > 0 &&
                          moshaverehPackages[2].inactiveDetails.map(
                            (detail, idx) => (
                              <li key={idx}>
                                {detail}
                                <span>
                                  <img src={inActiveIcon} alt="" />
                                </span>
                              </li>
                            )
                          )}
                      </ul>
                      <div className="price-texts">
                        {moshaverehPackages[2].price !==
                          moshaverehPackages[2].priceTakhfif && (
                          <p className="text-danger text-decoration-line-through">
                            {separate(moshaverehPackages[2].price)} تومان
                          </p>
                        )}
                        <p className="main-price fs-5">
                          {separate(moshaverehPackages[2].priceTakhfif)} تومان
                        </p>
                      </div>
                      <div className="w-100 d-flex align-items-center justify-content-center">
                        {moshaverehPackages[2]?.inventory > 0 ? (
                          <button
                            onClick={(e) =>
                              handleAddToBasket(e, moshaverehPackages[2])
                            }
                            className="plan-btn fw-bold fs-6"
                          >
                            افزودن به سبد خرید
                          </button>
                        ) : (
                          <button
                            disabled
                            className="plan-btn disabled-btn fw-bold fs-6"
                          >
                            ظرفیت تکمیل
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="note-titles">
            <p>
              بعد از پرداخت هزینه، تلگرام پیام دهید. یا اگر سوالاتی در مورد روند
              مشاوره دارید، ابتدا در تلگرام با پشتیبانی ما هماهنگ نمایید.
            </p>
            <p>
              برای اطلاع از شرایط مشاوره پره انترنی، در تلگرام با ما در ارتباط
              باشد.
            </p>
          </div>
        </div>

        <div className="readingBox-example d-flex flex-column align-items-center justify-content-center gap-5">
          <h3 className="main-title">
            <span>نمونه باکس مطالعاتی(پکیج های </span>کامل و VIP <span>)</span>
          </h3>
          <div className="reading-box-container d-flex align-items-center justify-content-center gap-5">
            <div className="reading-box">
              <img src={readingBox1} alt="" />
            </div>
            <div className="reading-box">
              <img src={readingBox2} alt="" />
            </div>
          </div>
        </div>
      </section>

      {/* OUR TEAM SECTION */}
      <section id="team" class="our-team mb-5">
        <div className="bg-overLay"></div>
        <div class="container">
          <div class="row">
            <div
              class="text-center col-12 section-title"
              data-aos="fade-zoom-in"
            >
              <h3 className="main-title">
                <span> گروه مشاوره دستیاری</span> آتروپین
              </h3>
            </div>
          </div>
          <div class="team-slider row" data-aos="fade-up">
            {teamData.map((item, index) => (
              <div className="col-12 col-md-6 col-lg-4 col-xl-3" key={index}>
                <div className="person-imgContainer">
                  <img src={item.imageUrl} alt="" />
                </div>
                {/* <div class="person text-center">
                  <img src={item.imageUrl} class=" mx-auto" alt="" />
                  <h3>{item.name}</h3>
                  <h5>{item.role}</h5>
                  <div>{item?.detail?.map(item => <p>{item}</p>)}
                  </div>
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SOALAT MOTADAVEL */}

      {/* <section id="faq" className="faq padding-100">
        <div className="container">
          <div className="row">
            <div
              className="text-center col-12 section-title"
              data-aos="fade-zoom-in"
            >
              <h3 className="main-title">
                <span>سوالات</span> متداول
              </h3>
              <p className="text-belowTitle">
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله
                در ستون و
              </p>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-md-8 col-12" data-aos="fade-left">
              <div className="accordion" id="faqAccordion">
                {faqData.map((item) => (
                  <div className="question-card shadow" key={item.id}>
                    <div className="card-header" id={`heading_${item.id}`}>
                      <h5 className="mb-0">
                        <button
                          className={`btn btn-link ${
                            activeId === item.id ? "" : "collapsed"
                          }`}
                          type="button"
                          onClick={() => handleAccordionClick(item.id)}
                        >
                          {item.question}
                        </button>
                      </h5>
                    </div>

                    <div
                      className={`answer-container ${
                        activeId === item.id ? "active" : ""
                      }`}
                    >
                      <div
                        className={`card-body ${
                          activeId === item.id ? "active" : ""
                        }`}
                      >
                        {item.answer}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div
              className="col-md-4 col-12 d-flex align-items-center"
              data-aos="fade-right"
              data-aos-delay="400"
            >
              <img src={questionImg} className="question-img" alt="" />
            </div>
          </div>
        </div>
      </section> */}

      {/* BLOGS(NEWS) SECTION */}
      <BlogNews />
    </div>
  );
};

export default Consultation;

// import React from "react";
// import { toast } from "react-toastify";
// import { GetMoshaverehData, Moshavereh } from "../../axios";
// import { useEffect } from "react";
// import { useState } from "react";
// import { useLocation } from "react-router-dom";

// const Consultation = (e) => {
//   const [firstName, setFirstName] = React.useState("");
//   const [lastName, setLastName] = React.useState("");
//   const [mobile, setMobile] = React.useState("");
//   const [explanation, setExplanation] = React.useState("");

//   const submitRequest = () => {
//     Moshavereh(mobile, firstName + " " + lastName, explanation).then(
//       toast.success("درخواست مشاوره شما با موفقیت ثبت شد")
//     );
//   };

//   const [moshaverehData, setMoshaverehData] = useState({});
//   useEffect(() => {
//     try {
//       GetMoshaverehData().then(({ data }) => {
//         setMoshaverehData(data[0]);
//       });
//     } catch (error) {
//       console.log(error.message);
//     }
//   }, []);

//   const { pathname } = useLocation();

//   // Automatically scrolls to top whenever pathname changes
//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   }, [pathname]);

//   return (
//     <div className="shop_area shop_reverse mt-60 mb-60 container">
//       <div className="row">
//         <div className="col-md-12" style={{ float: "none", margin: "auto" }}>
//           <div className="container-lg">
//             <h4>گروه مشاوره آتروپین</h4>
//             <img
//               src={moshaverehData.aks}
//               className="border shadow-sm rounded-2"
//               alt="Moshavereh_aks"
//               style={{ height: "100%", width: "100%", objectFit: "fill" }}
//             />
//           </div>
//           <div className="container col-lg-5 col-md-12">
//             <p className="mt-2" style={{ whiteSpace: "pre-line" }}>
//               {moshaverehData.matn}
//             </p>
//             <div className="mt-4">
//               <label>نام</label>
//               <input
//                 type="text"
//                 onChange={(e) => setFirstName(e.target.value)}
//                 id="first_name"
//                 name="first_name"
//                 className="form-control"
//               />
//             </div>
//             <div className="mt-4">
//               <label>نام و نام خانوادگی</label>
//               <input
//                 type="text"
//                 onChange={(e) => setLastName(e.target.value)}
//                 id="last_name"
//                 name="last_name"
//                 className="form-control"
//               />
//             </div>
//             <div className="mt-4">
//               <label>موبایل</label>
//               <input
//                 type="text"
//                 onChange={(e) => setMobile(e.target.value)}
//                 id="mobile"
//                 name="mobile"
//                 className="form-control"
//               />
//             </div>
//             <div className="mt-4">
//               <label>توضیحات</label>
//               <textarea
//                 type="text"
//                 onChange={(e) => setExplanation(e.target.value)}
//                 id="explanation"
//                 name="explanation"
//                 className="form-control"
//               />
//             </div>
//             <div className="mt-4">
//               <button onClick={submitRequest} className="btn btn-success">
//                 ثبت درخواست مشاوره
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Consultation;
